import {Component, EventEmitter, OnInit, Output, TemplateRef, ViewChild} from '@angular/core';
import {RegistrationData, LoginUser} from '../../models/models';
import {Translation} from '../../models/translation';
import {LoginService} from '../../services/login.service';
import {UserService} from '../../services/user.service';
import {TranslationService} from '../../services/translation.service';
import {ChangePasswordService} from '../../services/change-password.service';
import {MaintenanceService} from '../../services/maintenance.service';
import {MatLegacyDialog as MatDialog} from '@angular/material/legacy-dialog';
import {ActivatedRoute, Router} from '@angular/router';
import {Location} from '@angular/common';
import {sha256} from 'js-sha256';
import Swal from 'sweetalert2';
import {environment} from '../../../environments/environment';

@Component({
  selector: 'app-hstlogin',
  templateUrl: './hstlogin.component.html',
  styleUrls: ['./hstlogin.component.css']
})
export class HstloginComponent implements OnInit {
  @ViewChild('callDialog') dialogTemplate: TemplateRef<any>;
  @ViewChild('callPasswordDialog') dialogPasswordTemplate: TemplateRef<any>;
  @Output() nameChange = new EventEmitter();
  @ViewChild('ngForm') ngForm: any;

  public registrationData = new RegistrationData();
  public translationVersion = environment.translationVersion;
  public translation: Translation = new Translation();
  public username = '';
  public password = '';
  public toast = Swal.mixin({ toast: true, position: 'top-right', timer: 5000, timerProgressBar: true, showConfirmButton: false});
  public email: string;
  public registrationPassword: string;
  public repeatedPassword: string;
  public christmas = false;

  constructor(
    private router: Router,
    private loginService: LoginService,
    private userService: UserService,
    private translationService: TranslationService,
    private changePasswordService: ChangePasswordService,
    private maintenanceService: MaintenanceService,
    private route: ActivatedRoute,
    private location: Location,
    private dialog: MatDialog
  ) { }

  ngOnInit() {
    if (localStorage.getItem('Translation') === null) {
      this.toast.fire('Downloading language package', '', 'info');
      localStorage.setItem('Language', 'DE');
      this.translationService.getTranslation(localStorage.getItem('Language')).subscribe(response => {
        if (response.Ok) {
          localStorage.setItem('Translation', JSON.stringify(response.Obj));
          this.translation = JSON.parse(localStorage.getItem('Translation'));
        } else if (response.Msg === 'Internal Server Error') { console.log(response.Ex); }
        if (response.Msg) { this.toast.fire({title: response.Msg, icon: response.Ok ? 'success' : 'error'}); }
      }, error => { this.toast.fire(this.translation.InternalServerError); });
    } else if (+JSON.parse(localStorage.getItem('Translation')).TranslationVersion !== this.translationVersion) {
      this.toast.fire('Downloading language package', '', 'info');
      this.translationService.getTranslation(localStorage.getItem('Language')).subscribe(response => {
        if (response.Ok) {
          localStorage.setItem('Translation', JSON.stringify(response.Obj));
          this.translation = JSON.parse(localStorage.getItem('Translation'));
        } else if (response.Msg === 'Internal Server Error') { console.log(response.Ex); }
        if (response.Msg) { this.toast.fire({title: response.Msg, icon: response.Ok ? 'success' : 'error'}); }
      }, error => { this.toast.fire(this.translation.InternalServerError); });
    } else {
      this.translation = JSON.parse(localStorage.getItem('Translation'));
    }
    this.loginService.checkLoginToken();
    const date = new Date();
    if (date.getMonth() === 11 && date.getDate() <= 25) {
      this.christmas = true;
    }

    // Process QueryParams
    this.route.queryParams.subscribe(params => {
      this.userService.getTempRegistrationDataById(params.guid).subscribe(response => {
        if (response.Ok) {
          this.registrationData.Company = response.Obj.Company;
          this.registrationData.Additive = response.Obj.Additive;
          this.registrationData.StreetAndNumber = response.Obj.StreetAndNumber;
          this.registrationData.Zip = response.Obj.Zip;
          this.registrationData.City = response.Obj.City;
          this.registrationData.Phone = response.Obj.Phone;
          this.registrationData.Email = response.Obj.Email;
          this.registrationData.FirstName = response.Obj.FirstName;
          this.registrationData.LastName = response.Obj.LastName;
          this.registrationData.Language = response.Obj.Language;
          this.location.replaceState('hstlogin');
        }
      });
    });
  }

  login(): void {
    this.maintenanceService.checkMaintenance().subscribe(response1 => {
      if (response1.Ok) {
        if (response1.Obj) {
          this.maintenanceService.getMaintenanceDateTime().subscribe(response2 => {
            if (response2.Ok) {
              sessionStorage.setItem('Maintenance', 'true');
              sessionStorage.setItem('MaintenanceDate', response2.Obj[0]);
              sessionStorage.setItem('MaintenanceTime', response2.Obj[1]);
            } else if (response2.Msg === 'Internal Server Error') { console.log(response2.Ex); }
            sessionStorage.setItem('ForceHideMaintenance', 'false');
            if (response2.Msg) { this.toast.fire({title: response2.Msg, icon: response2.Ok ? 'success' : 'error'}); }
          }, error => {
            this.toast.fire(this.translation.InternalServerError);
            return;
          });
        } else {
          sessionStorage.setItem('Maintenance', 'false');
          sessionStorage.setItem('MaintenanceDate', '');
          sessionStorage.setItem('MaintenanceTime', '');
        }
      } else if (response1.Msg === 'Internal Server Error') { console.log(response1.Ex); }
      if (response1.Msg) { this.toast.fire({title: response1.Msg, icon: response1.Ok ? 'success' : 'error'}); }
    }, error => {
      this.toast.fire(this.translation.InternalServerError);
      return;
    });
    if (!this.username) {
      Swal.fire(this.translation.Error, this.translation.UserNameMustBeFilled, 'error').then(r => r);
      return;
    }
    if (!this.password) {
      Swal.fire(this.translation.Error, this.translation.PasswordMustBeFilled, 'error').then(r => r);
      return;
    }

    this.loginService.login(this.username, sha256(this.password)).subscribe((loginUser: LoginUser) => {
      if (loginUser) {
        sessionStorage.setItem('Token', loginUser.access_token);
        sessionStorage.setItem('ExpireDate', loginUser['.expires']);
        this.userService.getUserById(Number(loginUser.Id)).subscribe(responseUser => {
          if (responseUser.Ok) {
            if (responseUser.Obj) {
              sessionStorage.setItem('UserId', responseUser.Obj.UserId.toString());
              sessionStorage.setItem('RightStatus', responseUser.Obj.RightStatus.toString());
              sessionStorage.setItem('LoginName', responseUser.Obj.LoginName);
              sessionStorage.setItem('Email', responseUser.Obj.Email);
              sessionStorage.setItem('Phone', responseUser.Obj.Phone);
              sessionStorage.setItem('FirstName', responseUser.Obj.FirstName);
              sessionStorage.setItem('LastName', responseUser.Obj.LastName);
              sessionStorage.setItem('Addresses', responseUser.Obj.Addresses);
              sessionStorage.setItem('Companies', responseUser.Obj.Companies);
              sessionStorage.setItem('FirstLogin', responseUser.Obj.FirstLogin ? 'true' : 'false');
              sessionStorage.setItem('TermsAndConditionRead', responseUser.Obj.TermsAndConditionRead ? 'true' : 'false');
              sessionStorage.setItem('MultiPartnerUser', responseUser.Obj.MultiPartnerUser ? 'true' : 'false');
              sessionStorage.setItem('ConfirmationMail', responseUser.Obj.ConfirmationMail ? 'true' : 'false');
              sessionStorage.setItem('ConfirmationMailAsked', responseUser.Obj.ConfirmationMailAsked ? 'true' : 'false');
              sessionStorage.setItem('SaturdayDelivery', responseUser.Obj.SaturdayDelivery ? 'true' : 'false');
              sessionStorage.setItem('WnExternal', responseUser.Obj.WnExternal ? 'true' : 'false');
              sessionStorage.setItem('WheelnewsAddress', JSON.stringify(responseUser.Obj.WheelnewsAddress));
              sessionStorage.setItem('PrimaryAddress', JSON.stringify(responseUser.Obj.WheelnewsAddress));
              sessionStorage.setItem('WheelnewsSpecial', window.location.href.split('/').pop().substring(0, 3));
              sessionStorage.setItem('Rights', '');
              sessionStorage.setItem('ProcessIds', responseUser.Obj.ProcessIds);
              sessionStorage.setItem('OrderSource', responseUser.Obj.OrderSource);
              sessionStorage.setItem('Modules', JSON.stringify(responseUser.Obj.Modules));
              if (responseUser.Obj.Rights.length !== 0) { sessionStorage.setItem('Rights', JSON.stringify(responseUser.Obj.Rights)); }
              this.nameChange.emit(responseUser.Obj.FirstName + ' ' + responseUser.Obj.LastName);
              this.router.navigate(['/home']).then(r => r);
            }
          } else if (responseUser.Msg === 'Internal Server Error') { console.log(responseUser.Ex); }
          if (responseUser.Msg) { this.toast.fire({title: responseUser.Msg, icon: responseUser.Ok ? 'success' : 'error'}); }
        }, error => { this.toast.fire(this.translation.InternalServerError); });
      }
    }, error => { this.toast.fire('Username or Password wrong.'); });
  }

  openRegistrationForm() {
    if (this.registrationData.Company === undefined) { this.registrationData.Company = ''; }
    if (this.registrationData.Additive === undefined) { this.registrationData.Additive = ''; }
    if (this.registrationData.StreetAndNumber === undefined) { this.registrationData.StreetAndNumber = ''; }
    if (this.registrationData.Zip === undefined) { this.registrationData.Zip = ''; }
    if (this.registrationData.City === undefined) { this.registrationData.City = ''; }
    if (this.registrationData.Phone === undefined) { this.registrationData.Phone = ''; }
    if (this.registrationData.Email === undefined) { this.registrationData.Email = ''; }
    if (this.registrationData.FirstName === undefined) { this.registrationData.FirstName = ''; }
    if (this.registrationData.LastName === undefined) { this.registrationData.LastName = ''; }
    if (this.registrationData.Language === undefined) { this.registrationData.Language = ''; }
    this.registrationData.Password = null;
    this.repeatedPassword = '';
    this.dialog.open(this.dialogTemplate);
  }

  send(){
    const mustBeFilled = ' ' + this.translation.MustBeFilled.charAt(0).toLowerCase() + this.translation.MustBeFilled.slice(1);
    if (this.registrationData.Company === '') { this.throwError(this.translation.Company + mustBeFilled); return; }
    if (this.registrationData.StreetAndNumber === '') { this.throwError(this.translation.StreetAndNumber + mustBeFilled); return; }
    if (this.registrationData.Zip === '') { this.throwError(this.translation.Zip + mustBeFilled); return; }
    if (this.registrationData.City === '') { this.throwError(this.translation.City + mustBeFilled); return; }
    if (this.registrationData.Phone === '') { this.throwError(this.translation.Phone + mustBeFilled); return; }
    if (this.registrationData.Email === '') { this.throwError(this.translation.Email + mustBeFilled); return; }
    if (this.registrationData.FirstName === '') { this.throwError(this.translation.Email + mustBeFilled); return; }
    if (this.registrationData.LastName === '') { this.throwError(this.translation.Email + mustBeFilled); return; }
    if (this.registrationPassword === '') { this.throwError(this.translation.Password + mustBeFilled); return; }
    if (this.repeatedPassword === '') { this.throwError(this.translation.RepeatPassword + mustBeFilled); return; }
    if (this.registrationPassword.length < 8) { this.throwError(this.translation.ResetPasswordNotification6); return; }
    if (this.registrationPassword !== this.repeatedPassword) { this.throwError(this.translation.RepeatPasswordNotCorrectMessage); return; }
    this.registrationData.Language = localStorage.getItem('Language').toString();
    this.registrationData.Password = btoa(this.registrationPassword);

    this.userService.registration(this.registrationData).subscribe(response => {
      if (response.Ok) {
        Swal.fire({
          title: this.translation.RegistrationSuccessful,
          text: response.Ok && response.Obj ? this.translation.YouCanLoginNow : response.Msg,
          showConfirmButton: true,
          showCancelButton: false,
          confirmButtonText: 'OK',
          confirmButtonColor: '#CC0000',
        }).then (o => { this.dialog.closeAll(); });
      } else if (response.Msg === 'Internal Server Error') { console.log(response.Ex); }
      if (response.Msg) { this.toast.fire({title: response.Msg, icon: response.Ok ? 'success' : 'error'}); }
    }, error => { this.toast.fire(this.translation.InternalServerError); });
  }

  cancel() {
    this.dialog.closeAll();
  }

  throwError(message: string) {
    Swal.fire({
      title: this.translation.Error,
      text: message,
      confirmButtonColor: '#CC0000',
      confirmButtonText: 'OK',
      showConfirmButton: true,
      showCancelButton: false
    });
  }

  changePassword(): void {
    this.userService.checkIfEmailExists(this.email).subscribe(responseExists => {
      if (responseExists.Ok) {
        if (responseExists.Obj) {
          this.changePasswordService.resetPasswordProcessPartOne(this.email).subscribe(response => {
            this.dialog.closeAll();
            if (response.Ok) {
              if (response.Obj) {
                Swal.fire(this.translation.Success, this.translation.ResetPasswordNotification1, 'success');
              }
            } else if (response.Msg === 'Internal Server Error') { console.log(response.Ex); }
            if (response.Msg) { this.toast.fire({title: response.Msg, icon: response.Ok ? 'success' : 'error'}); }
          }, error => {
            this.dialog.closeAll();
            this.toast.fire(this.translation.InternalServerError); });
        } else {
          Swal.fire(this.translation.Error, this.translation.ResetPasswordNotification3, 'error');
        }
      } else if (responseExists.Msg === 'Internal Server Error') { console.log(responseExists.Ex); }
      if (responseExists.Msg) { this.toast.fire({title: responseExists.Msg, icon: responseExists.Ok ? 'success' : 'error'}); }
    }, error => { this.toast.fire(this.translation.InternalServerError); });
  }

  openResetPasswordForm() {
    this.dialog.open(this.dialogPasswordTemplate);
  }
}
